import { render, staticRenderFns } from "./MatrizProductoPantalla.vue?vue&type=template&id=75d4ab71&"
import script from "./MatrizProductoPantalla.vue?vue&type=script&lang=ts&"
export * from "./MatrizProductoPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports